import React from 'react'
import { Link } from 'react-router-dom'

import Card from '../layout/Card'
import Tag from '../content/Tag'
import Image from '../image'
import Circle from '../image/Circle'
import ClickableCard from '../layout/ClickableCard'
import PartnerIcon from './PartnerIcon'

type Props = {
  id: number
  logoSrc: string
  name: string
  industry: string
  sector?: string
  flagSrc: string
  small?: boolean
  isPartner?: boolean
}
const CompanyCard:React.FC<Props> = ({ id, name, logoSrc, industry, sector, flagSrc, small, isPartner }) => {
  const defaultSizeCard = () => (
    <Card className='w-full'>
      <div className='relative'>
        <div className='flex flex-row justify-end h-10'>
          {isPartner && <PartnerIcon />}
        </div>
        <div className='pt-2 p-6 box-content'><Image className='mx-auto w-40 h-20 md:h-24 md:w-60 object-contain' src={logoSrc} alt={name} /></div>
        <div className='border-b border-solid border-gray-100 flex flex-row justify-end'>
        </div>
        <div className='flex items-center gap-x-2 mt-2'>
          <Circle src={flagSrc} />
          <Tag solid>{industry}</Tag>
          {sector && <div className='hidden lg:block truncate'><Tag solid>{sector}</Tag></div>}
        </div>
      </div>
    </Card>
  )

  const smallCard = () => (
    <Card className='w-full h-27 sm:py-3.5'>
      <div className='relative flex flex-wrap items-end justify-between'>
        <Image className='h-20 w-24 md:h-22 md:w-36 object-contain' src={logoSrc} alt={name} />
        <div className='flex items-center justify-between gap-x-2'>
            <Circle src={flagSrc} />
            <Tag solid>{industry}</Tag>
        </div>
      </div>
    </Card>
  )

  return (
    <ClickableCard>
      <Link to={`/companies/${id}`}>
        {small ? smallCard() : defaultSizeCard()}
      </Link>
    </ClickableCard>
  )
}

export default CompanyCard
